export default __webpack_public_path__ + "static/media/amex.62343ab0.png";